module.exports = new __parcel__URL__("boceto2.664d807b.png").toString();